module.exports = __webpack_public_path__ + "img/OANDA_Onboarding_HeaderAnim_NL.9677b779.png";